import React from 'react';
import PersonCount from './PersonCount/PersonCount';
import TimePicker from './TimePicker/TimePicker';
import DatePicker from './DatePicker/DatePicker';
import { ICalendar } from 'src/entities/calendar';
import { IService } from 'src/entities/service';
import { WrappedComponentProps } from 'react-intl';
import { IPendingReservation } from 'src/entities/reservation';
import { ReadonlyInfo } from 'src/components/ReadonlyInfo/ReadonlyInfo';


export interface IDateTimeSelectBase {
    calendar?: ICalendar;
    service?: IService;
    personCount: number;
    autoSelect?: string;
    allowAlreadySelected: boolean;
    isOnlyService?: boolean;
    pendingReservations: IPendingReservation[];
    modifiedReservationId?: number;
}

interface IDateTimeSelectProps extends IDateTimeSelectBase {
    onDateChange: (newDate: string) => void;
    onTimeChange: (newTime?: string, clicked?: boolean) => void;
    onPersonCountChange: (newPersonCount: number) => void;
    time?: string;
    date: string;
    firstFreeDay: string;
    calendarChanged?: boolean;
    clickedByUser?: boolean;
}

const DateTimeSelect: React.FunctionComponent<IDateTimeSelectProps & WrappedComponentProps> = ({ calendarChanged, firstFreeDay, calendar, service, intl, autoSelect, allowAlreadySelected, time, onTimeChange, date, onDateChange, personCount, onPersonCountChange, isOnlyService, pendingReservations, modifiedReservationId, clickedByUser }) => {

    const calculateFirstFreeDay = () => {
        if (modifiedReservationId && date && date < firstFreeDay) {
            return date;
        }

        return firstFreeDay;
    }

    return (
        <section className="date-time-select">
            {calendar && calendar.Readonly &&
                <ReadonlyInfo phoneNumber={calendar.PhoneNumber} />
            }
            {!modifiedReservationId &&
                <PersonCount
                    maxCount={calendar ? calendar.ConcurrentNum : 0}
                    count={personCount}
                    onChange={onPersonCountChange}
                    className="date-time-select__person-count"
                />
            }
            <div className="date-time-select__main">
                <DatePicker
                    calendar={calendar}
                    service={service}
                    personCount={personCount}
                    firstFreeDay={calculateFirstFreeDay()}
                    value={date}
                    onChange={onDateChange}
                    autoSelect={autoSelect}
                    locale={intl.locale}
                    allowAlreadySelected={allowAlreadySelected}
                    isOnlyService={isOnlyService}
                    pendingReservations={pendingReservations}
                    modifiedReservationId={modifiedReservationId}
                    calendarChanged={calendarChanged}
                    clickedByUser={clickedByUser}
                />
                <TimePicker
                    calendar={calendar}
                    service={service}
                    personCount={personCount}
                    selectedDate={date}
                    value={time}
                    onChange={onTimeChange}
                    autoSelect={autoSelect}
                    formatTime={intl.formatTime}
                    allowAlreadySelected={allowAlreadySelected}
                    isOnlyService={isOnlyService}
                    pendingReservations={pendingReservations}
                    modifiedReservationId={modifiedReservationId}
                    calendarChanged={calendarChanged}
                    clickedByUser={clickedByUser}
                />
            </div>
        </section>
    )
}

export default DateTimeSelect